module.exports = __webpack_public_path__ + "static/media/ic_weguest.1cc390ed.png";